export enum Platforms {
  WEB = '1',
  SPARKLE = '2',
  TV = '3',
}

type CommonErrorsCategory =
  | 'MEDIA_ERR_ABORTED'
  | 'MEDIA_ERR_NETWORK'
  | 'MEDIA_ERR_DECODE'
  | 'MEDIA_ERR_SRC_NOT_SUPPORTED'
  | 'MEDIA_ERR_ENCRYPTED'
  | 'PLAYER_ERR_TIMEOUT'
  | 'PLAYER_ERR_NO_SRC'
  | 'unknown';

export enum CodeErrors {
  MEDIA_ERR_ABORTED = '1',
  MEDIA_ERR_NETWORK = '2',
  MEDIA_ERR_DECODE = '3',
  MEDIA_ERR_SRC_NOT_SUPPORTED = '4',
  MEDIA_ERR_ENCRYPTED = '5',
  PLAYER_ERR_TIMEOUT = '-2',
  PLAYER_ERR_NO_SRC = '-1',
  UNKNOWN = 'unknown',
}

export enum CustomCodeErrors {
  MEDIA_ERR_ABORTED = '0001',
  MEDIA_ERR_NETWORK = '0002',
  MEDIA_ERR_DECODE = '0003',
  MEDIA_ERR_SRC_NOT_SUPPORTED = '0004',
  MEDIA_ERR_ENCRYPTED = '0005',
  PLAYER_ERR_TIMEOUT = '0006',
  PLAYER_ERR_NO_SRC = '0007',
  UNKNOWN = '0404',
}

export type CommonErrorsType = {
  code: CodeErrors;
  custom_code: CustomCodeErrors;
  category: CommonErrorsCategory;
};

export interface IPlayerError {
  headline: string;
  message: string;
  code: CustomCodeErrors;
  platform: Platforms;
}

export type CustomMessage = {
  [keyof in CodeErrors]: IPlayerError;
};
